import { Box, Paper, Skeleton } from "@mui/material";
import React from "react"

const TicketDetailsSkeleton = () => (
  <Box sx={{ mt: 1 }}>
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "180px 1fr 180px 1fr",
        rowGap: 1,
        columnGap: 2,
      }}
    >
      {Array.from({ length: 8 }).map((_, index) => (
        <React.Fragment key={index}>
          <Skeleton height={25} />
          <Skeleton height={25} />
        </React.Fragment>
      ))}
    </Box>

    <Skeleton variant="text" width={180} height={35} sx={{ mt: 2 }} />

    <Skeleton variant="rectangular" height={100} sx={{ borderRadius: 1 }} />

    <Skeleton variant="text" width={220} height={35} sx={{ mt: 2 }} />

    <Skeleton variant="rectangular" height={80} sx={{ borderRadius: 1 }} />

    <Skeleton variant="text" width={180} height={35} sx={{ mt: 2 }} />

    {[1, 2, 3].map((item) => (
      <Paper
        key={item}
        variant="outlined"
        sx={{
          p: 1.5,
          mb: 1,
        }}
      >
        <Skeleton height={20} width="80%" />
        <Skeleton height={20} width="40%" />
      </Paper>
    ))}

    <Skeleton variant="text" width={150} height={35} sx={{ mt: 2 }} />

    <Skeleton variant="rectangular" height={120} sx={{ borderRadius: 1 }} />

    <Skeleton variant="rectangular" width={140} height={36} sx={{ mt: 1 }} />
  </Box>
);

export default TicketDetailsSkeleton;
